import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from '@/components/ui/dialog';
import { PrematuritateDataTabs } from './PrematuritateDataTabs';
import { Patient } from '@/types/patient.types';
import { Baby, Maximize2, Minimize2, X } from 'lucide-react';

interface PrematuritateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  patient: Patient;
  onDataUpdated?: () => void;
  readOnly?: boolean;
}

export const PrematuritateModal: React.FC<PrematuritateModalProps> = ({
  open,
  onOpenChange,
  patient,
  onDataUpdated,
  readOnly = false,
}) => {
  const [isMaximized, setIsMaximized] = useState(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideClose
        className={isMaximized ? "w-screen h-screen max-w-none max-h-none overflow-y-auto flex flex-col" : "max-w-6xl max-h-[90vh] overflow-y-auto"}
      >
        <DialogHeader>
          <div className="flex items-center justify-between">
            <div>
              <DialogTitle className="flex items-center gap-2">
                <Baby className="h-5 w-5" />
                Date prematuritate - {patient.name}
              </DialogTitle>
              <DialogDescription className={readOnly ? undefined : 'sr-only'}>
                {readOnly
                  ? 'Vizualizare date de prematuritate pentru acest pacient (doar citire).'
                  : 'Gestionați datele de prematuritate pentru acest pacient.'}
              </DialogDescription>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => setIsMaximized(!isMaximized)}
                className="inline-flex h-8 w-8 items-center justify-center rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                aria-label={isMaximized ? 'Micșorează fereastra' : 'Maximizează fereastra'}
              >
                {isMaximized ? (
                  <Minimize2 className="h-4 w-4" />
                ) : (
                  <Maximize2 className="h-4 w-4" />
                )}
              </button>
              <DialogClose asChild>
                <button
                  type="button"
                  className="inline-flex h-8 w-8 items-center justify-center rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  aria-label="Închide dialogul"
                >
                  <X className="h-4 w-4" />
                </button>
              </DialogClose>
            </div>
          </div>
        </DialogHeader>

        <div className="mt-4">
          <PrematuritateDataTabs
            patientId={patient.id}
            patient={patient}
            onDataUpdated={onDataUpdated}
            readOnly={readOnly}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
